module.exports = __webpack_public_path__ + "assets/images/pages/workshops/form-bg.png?7d278297";